import { apiInstance } from "@/api/instance";

export default async function () {
  return apiInstance.get("/youtube", { params: { size: 4 } });
}
